import DynamicTable from '@atlaskit/dynamic-table';
import { SpinnerMask } from '@atlassian/amkt-common';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { LineChart } from '@atlassian/mpac-ui';
import { DynamicTableUtils } from '@atlassian/mpac-utils';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { useResultsPerPage } from '../../../../common/components/useResultsPerPage';
import { TABLE_NAMES } from '../../../constants/Preferences';
import NoResultView from '../../../utils/NoResultView';
import { LineChartWrapper } from '../Common/ChartUtils';
import ErrorMessage from '../Common/ErrorMessage';
import { REPORTS_NO_RESULT_SUBTITLE, REPORTS_NO_RESULT_TITLE } from '../PartnerReports.constants';
import ReportChartTooltip from '../ReportChartTooltip';
import ChartControls from '../ReportsFilters/ChartControls';
import { getChartData, getChartTooltipPairs, lineChartDetails } from './CloudChurnBenchmark.utils';
import CloudChurnBenchmarkSummary from './CloudChurnBenchmarkSummaryData';
import { CloudChurnBenchmarkHeader, getCloudChurnBenchmarkBody } from './CloudChurnBenchmarkTableData';
import { useCloudChurnBenchmark } from './hooks';
const chartTooltip = _ref => {
  let {
    active,
    label,
    payload
  } = _ref;
  if (active && payload && payload.length) {
    const pairs = getChartTooltipPairs(payload);
    return /*#__PURE__*/React.createElement(ReportChartTooltip, {
      head: label,
      pairs: pairs
    });
  }
  return null;
};
function CloudChurnBenchmark(props) {
  var _cloudChurnBenchmarkA;
  const {
    resultsPerPageComponent,
    resultsPerPage
  } = useResultsPerPage(TABLE_NAMES.REPORTING_TABLE);
  const {
    cloudChurnBenchmarkAPIResponse,
    pending,
    error
  } = useCloudChurnBenchmark(props.mpacBaseUrl, props.partnerId, props.queryParams);
  const {
    enableReportsAccessibilityChanges
  } = useFeatureFlags();
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(ErrorMessage, {
    error: error.error,
    status: error.status
  }), !error && /*#__PURE__*/React.createElement(SpinnerMask, {
    active: pending,
    size: 50
  }, !pending && /*#__PURE__*/React.createElement(React.Fragment, null, cloudChurnBenchmarkAPIResponse && cloudChurnBenchmarkAPIResponse.churnBenchmarkPerApp != null && cloudChurnBenchmarkAPIResponse.churnBenchmarkPerApp.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LineChartWrapper, {
    enableReportsAccessibilityChanges: enableReportsAccessibilityChanges
  }, /*#__PURE__*/React.createElement(LineChart, {
    lines: lineChartDetails,
    data: getChartData(cloudChurnBenchmarkAPIResponse),
    xLabelFormat: value => "".concat(value),
    yLabelFormat: value => "".concat(value),
    tooltip: chartTooltip,
    isChartDeEmphasised: props.linePatternsUsageUserPreference.isUpdateLinePatternUsageUserPreferencePending
  }), /*#__PURE__*/React.createElement(ChartControls, {
    linePatternsUsageUserPreference: {
      value: props.linePatternsUsageUserPreference.value,
      onPreferenceChange: props.linePatternsUsageUserPreference.onPreferenceChange
    }
  })), /*#__PURE__*/React.createElement(CloudChurnBenchmarkSummary, {
    dataset: cloudChurnBenchmarkAPIResponse,
    period: props.queryParams.period,
    reportName: props.reportName
  })), /*#__PURE__*/React.createElement(React.Fragment, null, resultsPerPageComponent, /*#__PURE__*/React.createElement(DynamicTable, {
    head: CloudChurnBenchmarkHeader,
    rows: getCloudChurnBenchmarkBody(cloudChurnBenchmarkAPIResponse),
    isLoading: pending,
    rowsPerPage: DynamicTableUtils.getRowsPerPage(cloudChurnBenchmarkAPIResponse === null || cloudChurnBenchmarkAPIResponse === void 0 ? void 0 : (_cloudChurnBenchmarkA = cloudChurnBenchmarkAPIResponse.churnBenchmarkPerApp) === null || _cloudChurnBenchmarkA === void 0 ? void 0 : _cloudChurnBenchmarkA.length, resultsPerPage),
    defaultSortKey: "churnRate",
    emptyView: /*#__PURE__*/React.createElement(NoResultView, {
      title: REPORTS_NO_RESULT_TITLE,
      subtitle: REPORTS_NO_RESULT_SUBTITLE
    })
  })))));
}
export default /*#__PURE__*/React.memo(CloudChurnBenchmark, isEqual);